import decode from 'jwt-decode';
import {BaseService} from './BaseService';
export default class AdministrationService extends BaseService {
  getProfile() {
      // Using jwt-decode npm package to decode the token
      return decode(this.getToken());
  }

  postSolicitud(solicitud) {
      return this.fetch(`${this.domain}/administration/equipment-request`, {
          method: 'POST',
          body: JSON.stringify({
            solicitud: solicitud,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  updateDevuelto(idsolicitud, idequipo, devueltoEquipo) {
      return this.fetch(`${this.domain}/administration/equipment-request/returned`, {
          method: 'PUT',
          body: JSON.stringify({
            idequipo,
            idsolicitud,
            devolucion: devueltoEquipo,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getEquipmentList(disponibles) {
    const url = new URL(`${this.domain}/administration/equipment-list`);
    const params = { disponibles };
    url.search = new URLSearchParams(params)
      return this.fetch(url, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  postEquipment(equipo) {
      return this.fetch(`${this.domain}/administration/equipment`, {
          method: 'POST',
          body: JSON.stringify({
            equipo: {
              id: equipo.id,
              nombre: equipo.nombre,
              devuelto: equipo.devuelto,
              descripcion: equipo.descripcion,
            }
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  deleteEquipment(idequipo) {
      return this.fetch(`${this.domain}/administration/equipment`, {
          method: 'DELETE',
          body: JSON.stringify({
            id: idequipo,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  deleteFacturaFondos(id) {
      return this.fetch(`${this.domain}/administration/factura-fondo`, {
          method: 'PUT',
          body: JSON.stringify({
            id: id,
          })
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  postRendicion(rendicion) {
    const formdata = new FormData();
    formdata.append('file', rendicion.file);
    formdata.append('numero', rendicion.numero);
    formdata.append('fecha', rendicion.fecha);
    formdata.append('tipo', rendicion.tipo);
    formdata.append('concepto', rendicion.concepto);
    formdata.append('condicion', rendicion.condicion);
    formdata.append('financia', rendicion.financia);
    formdata.append('proveedor', rendicion.proveedor);
    formdata.append('inventario', rendicion.inventario);
    formdata.append('neto', rendicion.neto);
    formdata.append('iva', rendicion.iva);
    formdata.append('total', rendicion.total);
    formdata.append('expediente', rendicion.expediente);
    formdata.append('proyectoid', rendicion.proyectoid);
    formdata.append('rendida', rendicion.rendida);
    formdata.append('responsable', rendicion.responsable);
    formdata.append('fasociada', rendicion.fasociada)
    formdata.append('id', rendicion.id);

    return fetch(`${this.domain}/administration/rendicion-factura`, {
          headers : {'Authorization':'Bearer ' + this.getToken()},
          method: 'POST',
          body: formdata,
        })
        .then(this._checkStatus)
        .then( response => {
          return Promise.resolve(response);
        });
  }

  getTiposComprobantes() {
    const url = new URL(`${this.domain}/administration/receipt-types`);
      return this.fetch(url, {
          method: 'GET',
      }).then(res => {
          return Promise.resolve(res);
      });
  }

  getFacturasAsociables() {
    const url = new URL(`${this.domain}/administration/associable-invoices`);
    return this.fetch(url, {
      method: 'GET',
    }).then(res => {
      return Promise.resolve(res);
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/AdministrationService.js